<template>
  <div class="container">
    <a-form :model="handleList" class="search-form" @submit="handleList">
      <a-form-item name="content">
        <div class="form-item-content">
          <div class="label">搜索内容：</div>
          <a-input
            placeholder="商品描述/订单详细"
            v-model:value="listRequest.content"
          />
        </div>
      </a-form-item>
      <a-form-item>
        <div class="form-item-content">
          <div class="label">下单类型：</div>
          <a-select style="width: 200px" v-model:value="listRequest.category">
            <a-select-option :value="1">商品订单</a-select-option>
            <a-select-option :value="2">信件订单</a-select-option>
            <a-select-option :value="3">明信片</a-select-option>
          </a-select>
        </div>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit">搜索</a-button>
        <a-button style="margin-left: 10px" @click="resetSearch">重置</a-button>
        <a-button style="margin-left: 10px" @click="xlsxExcel">导出</a-button>
        <a-button style="margin-left: 10px" @click="allUpdate"
          >全部寄出</a-button
        >
      </a-form-item>
    </a-form>

    <a-table
      :columns="columns"
      :data-source="productList"
      :pagination="{
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total,
        defaultPageSize: listRequest.size,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40, 50],
        onChange: handleChange,
        onShowSizeChange: handleSizeChange,
      }"
      bordered
      :scroll="{ x: 1000, y: 600 }"
      style="min-width: 600px"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'is_delete'">
          <a-tag v-if="record.is_delete === 1" color="green">正常</a-tag>
          <a-tag v-if="record.is_delete === 2" color="red">回收站</a-tag>
        </template>
        <template v-else-if="column.dataIndex === 'status'">
          <a-tag v-if="record.status === 1" color="green">可用</a-tag>
          <a-tag v-if="record.status === 2" color="red">禁用</a-tag>
        </template>
        <template v-else-if="column.dataIndex === 'image_url'">
          <div
            v-if="record.image_url !== undefined && record.image_url !== null"
          >
            <a-image
              v-for="i in record.image_url.slice(0, 2)"
              :key="i"
              :src="ToImage(i)"
              style="height: 60px; width: auto; margin-top: 5px"
            />
          </div>
        </template>
        <template v-else-if="column.dataIndex === 'create_at'">
          <span
            >{{ dayjs(record.create_at).format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </template>
        <template v-else-if="column.dataIndex === 'update_at'">
          <span
            >{{ dayjs(record.update_at).format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </template>
        <template v-else-if="column.dataIndex === 'operator'">
          <a-button
            @click="handleView(record)"
            type="primary"
            size="small"
            :style="{ marginRight: '8px' }"
            >查看
          </a-button>
          <a-button
            @click="handleReply(record)"
            type="primary"
            size="small"
            :style="{
              backgroundColor: '#74eeb9',
              color: 'white',
              marginRight: '8px',
            }"
            >回信
          </a-button>
          <a-button
            @click="handleDelivery(record)"
            type="primary"
            size="small"
            :style="{
              backgroundColor: '#ee74cb',
              color: 'white',
              marginRight: '8px',
            }"
            >查看物流信息
          </a-button>
          <a-button
            @click="handleMailUpdate(record)"
            type="primary"
            size="small"
            :style="{
              backgroundColor: '#d074ee',
              color: 'white',
              marginRight: '8px',
              marginTop: '4px',
            }"
            >已寄出
          </a-button>
          <a-modal
            v-model:open="visMailUpdate"
            title="修改物流信息"
            @ok="submitOrderUpdateStatus"
            cancelText="取消"
          >
            <a-form :model="orderUpdateRequest">
              <a-form-item label="快递单号">
                <a-input v-model:value="orderUpdateRequest.delivery_number" />
              </a-form-item>
            </a-form>
          </a-modal>
          <a-button
            @click="handlePrint(record)"
            type="primary"
            size="small"
            :style="{
              backgroundColor: '#74bbee',
              color: 'white',
              marginRight: '8px',
            }"
            >打印地址
          </a-button>
          <a-button
            @click="handleOrderUpdate(record)"
            type="primary"
            size="small"
            :style="{
              backgroundColor: '#7476ee',
              color: 'white',
              marginRight: '8px',
              marginTop: '4px',
            }"
            >修改内容
          </a-button>
          <!--a-button
            @click="submitDelete(record)"
            type="primary"
            size="small"
            :style="{
              backgroundColor: '#ff7a45',
              color: 'white',
              marginRight: '8px',
              marginTop: '4px',
            }"
            >删除
          </a-button>
          <a-button
            @click="submitDrop(record)"
            type="primary"
            size="small"
            :style="{
              backgroundColor: '#ff4d4f',
              color: 'white',
              marginRight: '8px',
              marginTop: '4px',
            }"
            >彻底删除
          </a-button=-->
        </template>
        <template v-else-if="column.dataIndex === 'category'">
          <a-tag v-if="record.category === 1" color="green">商品订单</a-tag>
          <a-tag v-if="record.category === 2" color="blue">信件订单</a-tag>
          <a-tag v-if="record.category === 3" color="yellow">明信片</a-tag>
        </template>
        <template v-else-if="column.dataIndex === 'write_category'">
          <a-tag v-if="record.write_category === 1" color="green"
            >在线填写
          </a-tag>
          <a-tag v-if="record.write_category === 2" color="blue"
            >手写拍照
          </a-tag>
          <a-tag v-if="record.write_category === 3" color="yellow"
            >钢笔代写
          </a-tag>
          <span v-else></span>
        </template>
        <template v-else-if="column.dataIndex === 'send_name'">
          <div>{{ record.send_name }}</div>
          <div>
            {{ record.send_province }} {{ record.send_city }}
            {{ record.send_district }}
          </div>
          <div>{{ record.send_address }}</div>
        </template>
        <template v-else-if="column.dataIndex === 'recipient_name'">
          <div>{{ record.recipient_name }}</div>
          <div>
            {{ record.recipient_province }} {{ record.recipient_city }}
            {{ record.recipient_district }}
          </div>
          <div>{{ record.recipient_address }}</div>
        </template>
        <template v-else-if="column.dataIndex === 'pay_method'">
          <a-tag v-if="record.pay_method === 1" color="yellow">余额支付</a-tag>
          <a-tag v-if="record.pay_method === 2" color="green">微信支付</a-tag>
        </template>
        <template v-else-if="column.dataIndex === 'platform'">
          <a-tag v-if="record.platform === 1" color="green">微信小程序</a-tag>
        </template>
      </template>
    </a-table>
  </div>
  <a-modal
    v-model:open="vis"
    :closable="false"
    :footer="null"
    width="1400px"
    title="订单详情"
  >
    <OrderDetail :order="order" />
  </a-modal>

  <a-modal
    v-model:open="visDelivery"
    :closable="false"
    :footer="null"
    width="1400px"
    title="物流信息"
  >
    <DeliveryView :accept="deliveryRequest" />
  </a-modal>

  <a-modal
    v-model:open="visPrint"
    :closable="false"
    :footer="null"
    width="800px"
    title="打印信息"
  >
    <DeliveryPrint :accept="accept" />
  </a-modal>

  <a-modal
    v-model:open="visReply"
    title="创建回信"
    @ok="submitReply"
    cancelText="取消"
  >
    <a-form :model="replyAddRequest">
      <a-form-item label="快递单号">
        <a-input v-model:value="splitMail1" />
        <a-input v-model:value="splitMail2" />
        <a-input v-model:value="splitMail3" />
        <a-input v-model:value="splitMail4" />
        <a-input v-model:value="splitMail5" />
      </a-form-item>
      <a-form-item label="回信状态">
        <a-select v-model:value="replyAddRequest.status">
          <a-select-option :value="1">待寄出</a-select-option>
          <a-select-option :value="2">运输中</a-select-option>
          <a-select-option :value="3">已完成</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="运输方式">
        <a-select v-model:value="replyAddRequest.mail_method_id">
          <a-select-option
            v-for="mail in mailList"
            :value="mail.id"
            :key="mail.id"
            >{{ mail.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="内容">
        <a-textarea v-model:value="replyAddRequest.content" :rows="4" />
      </a-form-item>
    </a-form>
  </a-modal>

  <a-modal
    v-model:open="visOrderUpdate"
    title="修改订单信息"
    @ok="submitOrderUpdate"
    cancelText="取消"
  >
    <a-form :model="orderUpdateRequest">
      <a-form-item label="快递单号">
        <a-input v-model:value="orderUpdateRequest.delivery_number" />
      </a-form-item>
      <a-form-item label="信件标题">
        <a-input v-model:value="orderUpdateRequest.title" />
      </a-form-item>
      <a-form-item label="信件作者">
        <a-input v-model:value="orderUpdateRequest.author" />
      </a-form-item>
      <a-form-item label="信件时间">
        <a-input v-model:value="orderUpdateRequest.write_date" />
      </a-form-item>
      <a-form-item label="内容">
        <a-textarea v-model:value="orderUpdateRequest.content" :rows="4" />
      </a-form-item>
      <a-form-item label="制作效果图">
        <File-Upload
          v-model="orderUpdateRequest.avatar"
          style="display: block"
        />
        <a-image
          v-if="orderUpdateRequest.avatar !== ''"
          :src="ToImage(orderUpdateRequest.avatar)"
          style="max-height: 150px; display: block; margin-top: 10px"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from "vue";
import { message } from "ant-design-vue";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import { ToImage } from "@/utils/image";
import { Product } from "@/api/models/product/Product";
import { ProductOrderService } from "@/api/services/ProductOrderService";
import { ProductOrder } from "@/api/models/product_order/ProductOrder";
import * as XLSX from "xlsx";
import {
  Print,
  ProductOrderListRequest,
} from "@/api/models/product_order/ProductOrderListRequest";
import OrderDetail from "@/components/OrderDetail.vue";
import { Mail } from "@/api/models/mail/Mail";
import { MailService } from "@/api/services/MailService";
import { ReplyAddRequest } from "@/api/models/reply/ReplyAddRequest";
import { ReplyService } from "@/api/services/ReplyService";
import { ProductOrderUpdateRequest } from "@/api/models/product_order/ProductOrderUpdateRequest";
import { DeliveryRequest } from "@/api/models/config/DeliveryRequest";
import DeliveryView from "@/components/DeliveryView.vue";
import DeliveryPrint from "@/components/DeliveryPrint.vue";
import FileUpload from "@/components/FileUpload.vue";
import { formToJSON } from "axios";

const vis = ref<boolean>(false);

const splitMail1 = ref<string>("");
const splitMail2 = ref<string>("");
const splitMail3 = ref<string>("");
const splitMail4 = ref<string>("");
const splitMail5 = ref<string>("");

const order = ref<ProductOrder>();

const handleView = (record: ProductOrder) => {
  vis.value = true;
  order.value = record;
};

dayjs.locale("zh-cn");

const total = ref<number>(0);

const listRequest = reactive<ProductOrderListRequest>({
  current: 1,
  size: 50,
  status: 2,
  content: "",
});

// @ts-ignore
const productList = ref<ProductOrder[]>([{}]);

const handleList = async () => {
  const res = await ProductOrderService.ListAll(listRequest);
  if (res.code === 0) {
    productList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};
const data = [["快递单号", "收件人姓名", "收件人地址", "寄件人电话"]];

const xlsxExcel = async () => {
  // 创建工作簿并添加工作表
  for (let n = 0; n < productList.value.length; n++) {
    data.push([
      productList.value[n].delivery_number,
      productList.value[n].recipient_name,
      productList.value[n].recipient_province +
        productList.value[n].recipient_city +
        productList.value[n].recipient_district +
        productList.value[n].recipient_address,
      productList.value[n].send_phone,
    ]);
  }

  const wb = XLSX.utils.book_new();
  // 创建工作表
  const ws = XLSX.utils.aoa_to_sheet(data);

  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  const currentTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
  // 导出Excel文件
  XLSX.writeFile(wb, currentTime + "快递信息.xlsx");
};

const resetSearch = async () => {
  listRequest.current = 1;
  listRequest.size = 5;
  listRequest.category = undefined;
  await handleList();
};

onMounted(async () => {
  await handleList();
});

const handleSizeChange = (current: number, pageSize: number) => {
  listRequest.current = current;
  listRequest.size = pageSize;
  handleList();
};

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const submitDelete = async (record: Product) => {
  const res = await ProductOrderService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: Product) => {
  const res = await ProductOrderService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const mailList = ref<Mail[]>([]);

const handleMailList = async () => {
  const res = await MailService.ListAll({ current: 0, size: 0 });
  if (res.code === 0) {
    mailList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

const visReply = ref<boolean>(false);

const replyAddRequest = reactive<ReplyAddRequest>({
  status: 1,
  mail_method_id: 2,
});

const handleReply = async (record: ProductOrder) => {
  visReply.value = true;
  replyAddRequest.product_order_id = record.id;
};

const submitReply = async () => {
  if (splitMail1.value.length > 0) {
    replyAddRequest.delivery_number = splitMail1.value;
    const res = await ReplyService.Add(replyAddRequest);
    if (res.code === 0) {
      message.success("添加回信1成功");
      setTimeout(() => location.reload(), 1000);
    } else {
      message.error(res.msg);
    }
  }
  if (splitMail2.value.length > 0) {
    replyAddRequest.delivery_number = splitMail2.value;
    const res = await ReplyService.Add(replyAddRequest);
    if (res.code === 0) {
      message.success("添加回信2成功");
      setTimeout(() => location.reload(), 1000);
    } else {
      message.error(res.msg);
    }
  }
  if (splitMail3.value.length > 0) {
    replyAddRequest.delivery_number = splitMail3.value;
    const res = await ReplyService.Add(replyAddRequest);
    if (res.code === 0) {
      message.success("添加回信3成功");
      setTimeout(() => location.reload(), 1000);
    } else {
      message.error(res.msg);
    }
  }
  if (splitMail4.value.length > 0) {
    replyAddRequest.delivery_number = splitMail4.value;
    const res = await ReplyService.Add(replyAddRequest);
    if (res.code === 0) {
      message.success("添加回信4成功");
      setTimeout(() => location.reload(), 1000);
    } else {
      message.error(res.msg);
    }
  }
  if (splitMail5.value.length > 0) {
    replyAddRequest.delivery_number = splitMail5.value;
    const res = await ReplyService.Add(replyAddRequest);
    if (res.code === 0) {
      message.success("添加回信5成功");
      setTimeout(() => location.reload(), 1000);
    } else {
      message.error(res.msg);
    }
  }
};

const visOrderUpdate = ref<boolean>(false);
const visMailUpdate = ref<boolean>(false);

const orderUpdateRequest = reactive<ProductOrderUpdateRequest>({});

const handleOrderUpdate = (record: ProductOrder) => {
  visOrderUpdate.value = true;
  Object.assign(orderUpdateRequest, record);
};

const allUpdate = async () => {
  const orderUpdateRequest2 = reactive<ProductOrderUpdateRequest>({});
  for (let n = 0; n < productList.value.length; n++) {
    if (
      productList.value[n].mail_method_name != "EMS" &&
      productList.value[n].delivery_number.length > 0
    ) {
      productList.value[n].status = 4;
      orderUpdateRequest2.id = productList.value[n].id;
      orderUpdateRequest2.delivery_number =
        productList.value[n].delivery_number;
      orderUpdateRequest2.status = productList.value[n].status;
      orderUpdateRequest2.title = productList.value[n].title;
      orderUpdateRequest2.content = productList.value[n].content;
      orderUpdateRequest2.author = productList.value[n].author;
      orderUpdateRequest2.write_date = productList.value[n].write_date;
      orderUpdateRequest2.avatar = productList.value[n].avatar;
      const res = await ProductOrderService.Update(orderUpdateRequest2);
      if (res.code === 0) {
        message.success("修改信息成功");
        setTimeout(() => location.reload(), 1000);
      } else {
        message.error(res.msg);
      }
    }
  }
};

const handleMailUpdate = (record: ProductOrder) => {
  visMailUpdate.value = true;
  Object.assign(orderUpdateRequest, record);
};

const submitOrderUpdate = async () => {
  const res = await ProductOrderService.Update(orderUpdateRequest);
  if (res.code === 0) {
    message.success("修改信息成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitOrderUpdateStatus = async () => {
  orderUpdateRequest.status = 4;
  const res = await ProductOrderService.Update(orderUpdateRequest);
  if (res.code === 0) {
    message.success("已寄出状态修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const visDelivery = ref<boolean>(false);

// @ts-ignore
const deliveryRequest = reactive<DeliveryRequest>({});

const handleDelivery = (record: ProductOrder) => {
  if (record.delivery_number === "") {
    message.error("快递单号不存在");
    return;
  }
  visDelivery.value = true;
  deliveryRequest.mail_method_name = record.mail_method_name;
  deliveryRequest.number = record.delivery_number;
};

const visPrint = ref<boolean>(false);

// @ts-ignore
const accept = reactive<ProductOrder>({});
const print = reactive<Print>({});
const handlePrint = (record: ProductOrder) => {
  print.id = record.id;
  print.s = 0;
  print.orderid = record.id;
  print.from_address = "广东省广州市黄埔区易博士大厦1栋526(芳18681417165代寄)";
  print.from_phone = record.send_phone;
  print.from_name = record.send_name;
  print.to_address =
    record.recipient_province +
    record.recipient_city +
    record.recipient_district +
    record.recipient_address;
  print.to_name = record.recipient_name;
  print.to_phone = record.recipient_phone;
  print.to_youbian = record.send_postcode;
  print.to_guanxi = record.relationship;
  ProductOrderService.PostPrint(print);
  //if (res.code === 0) {
  message.success("已经发送至打印机打印");
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
    width: 100,
  },
  {
    title: "订单号",
    dataIndex: "order_id",
    align: "center",
  },
  {
    title: "下单时间",
    dataIndex: "create_at",
    align: "center",
  },
  // {
  //   title: "会员",
  //   dataIndex: "user_open_id",
  //   align: "center",
  // },
  // {
  //   title: "邮寄方式",
  //   dataIndex: "mail_method_name",
  //   align: "center",
  // },
  {
    title: "总费用",
    dataIndex: "total_price",
    align: "center",
    width: 100,
  },
  {
    title: "快递单号",
    dataIndex: "delivery_number",
    align: "center",
    width: 150,
  },
  {
    title: "上传照片",
    dataIndex: "image_url",
    align: "center",
    width: 150,
  },
  // {
  //   title: "订单类别",
  //   dataIndex: "category",
  //   align: "center",
  // },
  // {
  //   title: "提交方式",
  //   dataIndex: "write_category",
  //   align: "center",
  // },
  {
    title: "发件人信息",
    dataIndex: "send_name",
    align: "center",
  },
  // {
  //   title: "发件人电话号码",
  //   dataIndex: "send_phone",
  //   align: "center",
  // },
  {
    title: "收件人信息",
    dataIndex: "recipient_name",
    align: "center",
  },
  // {
  //   title: "收件人电话号码",
  //   dataIndex: "recipient_phone",
  //   align: "center",
  // },
  // {
  //   title: "支付方式",
  //   dataIndex: "pay_method",
  //   align: "center",
  // },
  // {
  //   title: "平台来源",
  //   dataIndex: "platform",
  //   align: "center",
  // },
  // {
  //   title: "修改时间",
  //   dataIndex: "update_at",
  //   align: "center",
  // },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
    width: 300,
  },
];

onMounted(() => {
  handleMailList();
});
</script>

<style scoped>
.container {
  border: 1px solid #d9d9d9;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 98%;
  margin-left: 1%;
  background-color: white;
  margin-top: 16px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 10px;
}

.form-item-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.label {
  white-space: nowrap;
}
</style>
